/*
  Écart entre deux sections encadrées qui se touchent (ex. Avis puis Étapes quand la section Ingrédients
  entre les deux est vide, ou deux sections dont les marges sont à 0) : le second encadré prend la classe
  .mh-box-gap (assets/mh-base.css). Les encadrés séparés par une marge ou une autre section ne bougent pas.
  Chargé sur toutes les pages (snippets/mh-tokens.liquid) ; recalculé au redimensionnement et dans l'éditeur.
*/
(() => {
  const BOXES = [
    '.mh-reviews__box',
    '.mh-steps__box',
    '.mh-commitments__box',
    '.mh-figures__box',
    '.mh-highlights__box',
    '.mh-stories__box',
    '.mh-cta__card',
  ].join(',');

  // Position dans la page sans les transformations (animations d'apparition de mh-reveal.js)
  function box(element) {
    let top = 0;
    let left = 0;
    for (let node = element; node; node = node.offsetParent) {
      top += node.offsetTop;
      left += node.offsetLeft;
    }
    return { top, left, bottom: top + element.offsetHeight, right: left + element.offsetWidth };
  }

  function update() {
    const boxes = [...document.querySelectorAll(BOXES)];
    boxes.forEach((box) => box.classList.remove('mh-box-gap'));
    const visible = boxes.filter((box) => box.getClientRects().length > 0);
    for (let i = 1; i < visible.length; i++) {
      const previous = visible[i - 1];
      const current = visible[i];
      if (previous.closest('.shopify-section') === current.closest('.shopify-section')) continue;
      const a = box(previous);
      const b = box(current);
      const touching = b.top - a.bottom < 1 && b.top > a.top;
      const overlapX = Math.min(a.right, b.right) - Math.max(a.left, b.left) > 0;
      if (touching && overlapX) current.classList.add('mh-box-gap');
    }
  }

  let frame;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(update);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', () => setTimeout(schedule, 0));
  document.addEventListener('shopify:section:reorder', schedule);
})();
